
<div *ngIf="termino === '0'" class="rounded" style="height: 90vh !important; background: linear-gradient(to bottom,#0B4595,#5578a8);">
    <div class="modal-content bg-body d-none d-md-block rounded" style="height: 90vh !important; background: url(./assets/img/nubes.svg)  !important ;">
        <!-- <div class="modal-header w-100 p-2" style="background-color: rgb(57, 55, 177); color: #fff; border-radius: 1rem 1rem 0 0;">
            <h3 class="modal-title" class=" text-center"><strong> Log in</strong> </h3>
        </div> -->
       <!--  <button  matTooltip="SALIR"  style="position: absolute; top: 1%; left: 1%; z-index: 2;" (click)="cerrarmodal()"  mat-mini-fab color="primary"> 
            <mat-icon >reply</mat-icon>
        </button> -->
        <div class="modal-body ">
            <div class="container-fluid" style="padding: 1%">
                <div class="row" style="margin-top: 10%;">
                    <div class="col-1"></div>
                    <div class="col-4 px-1 pt-5">
                        <img src="./assets/img/speaky_t.svg" width="200px">
                    </div>
                    <div class="col-6 container">
                        <div class="row">
                            <div class="col-12 d-flex justify-content-center">
                                <img src="./assets/img/Logo_speakup.png" width="100px" class="mb-3">
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12 d-flex justify-content-center">
                                <h1 class="fw-bold text-white mb-4">TEST DE NIVELACIÓN DE INGLÉS</h1>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12 d-flex justify-content-center">
                                <p class=" text-white mb-4">Consta de 40 preguntas de selección simple y completación de frases con un temporizador.</p>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12 d-flex justify-content-center">
                                <p class=" text-white mb-4">Está diseñado para evaluar el conocimiento del inglés desde el nivel A1 hasta el B2 del MCER. </p>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12 d-flex justify-content-center">
                                <p class=" text-white mb-4">Se te ubicará en el nivel correspondiente dependiendo las respuestas correctas. </p>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12">
                                <button  mat-raised-button (click)="modalrespuesta()" class="text-white w-100" style="background-color: #50E170;">¡Comenzar ya!</button>
                            </div>
                        </div>
                    </div>
                    <div class="col-1"></div>
                </div>
            </div>
        </div>
    </div>
</div>
<div *ngIf="termino === '1'" class="rounded" style="height: 90vh !important; background: linear-gradient(to bottom,#0B4595,#5578a8);">
    <div class="modal-content bg-body d-none d-md-block rounded" style="height: 90vh !important; background: url(./assets/img/nubes.svg)  !important ;">
        <!-- <div class="modal-header w-100 p-2" style="background-color: rgb(57, 55, 177); color: #fff; border-radius: 1rem 1rem 0 0;">
            <h3 class="modal-title" class=" text-center"><strong> Log in</strong> </h3>
        </div> -->
       <!--  <button  matTooltip="SALIR"  style="position: absolute; top: 1%; left: 1%; z-index: 2;" (click)="cerrarmodal()"  mat-mini-fab color="primary"> 
            <mat-icon >reply</mat-icon>
        </button> -->
        <img src="./assets/img/fondo_speaky.svg" width="750px" style="position: absolute; bottom: 0; left: 5%;">
        <div class="modal-body ">
            <div class="container-fluid" style="padding: 1%">
                <div class="row" style="padding-top: 15%;">
                    <div class="col-1"></div>
                    <div class="col-10 container">
                        <div class="row">
                            <div class="col-12 d-flex justify-content-center">
                                <img src="./assets/img/Logo_speakup.png" width="100px" class="mb-3">
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12 d-flex justify-content-center">
                                <h1 class="fw-bold text-white mb-4">¡FELICITACIONES POR COMPLETAR NUESTRO TEST DE NIVELACIÓN!</h1>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12 d-flex justify-content-center">
                                <p class=" text-white mb-4">Si deseas conocer tus resultados, puedes suscribirte con nuestra Membresía PREMIUM.</p>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12 d-flex justify-content-center">
                                <p class=" text-white mb-4">¡Aprende Inglés con nosotros y desbloquea TODO TU POTENCIAL! </p>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12 d-flex justify-content-center gap-3">
                                <button  mat-raised-button (click)="cerrarmodal()" class="text-white mr-2" color="warn" >NO gracias, en otro momento</button>
                                <button  mat-raised-button (click)="modalInfo()" class="text-white" style="background-color: #50E170;">¡QUIERO TENER MÁS INFORMACIÓN!</button>
                            </div>
                        </div>
                    </div>
                    <div class="col-1"></div>
                </div>
            </div>
        </div>
    </div>
</div>
<div *ngIf="termino === '2'" class="rounded" style="height: 90vh !important; background: linear-gradient(to bottom,#0B4595,#5578a8);">
    <div class="modal-content bg-body d-none d-md-block rounded" style="height: 90vh !important; background: url(./assets/img/nubes.svg)  !important ;">
        <!-- <div class="modal-header w-100 p-2" style="background-color: rgb(57, 55, 177); color: #fff; border-radius: 1rem 1rem 0 0;">
            <h3 class="modal-title" class=" text-center"><strong> Log in</strong> </h3>
        </div> -->
       <!--  <button  matTooltip="SALIR"  style="position: absolute; top: 1%; left: 1%; z-index: 2;" (click)="cerrarmodal()"  mat-mini-fab color="primary"> 
            <mat-icon >reply</mat-icon>
        </button> -->
        <div class="modal-body ">
            <div class="container-fluid" style="padding: 1%">
                <div class="row" style="margin-top: 2.5%;">
                    <div class="col-1"></div>
                    <div class="col-4 px-1 pt-5">
                        <img src="./assets/img/speaky_free.svg" width="350px">
                    </div>
                    <div class="col-6 container">
                        <div class="row">
                            <div class="col-12 d-flex justify-content-center">
                                <img src="./assets/img/Logo_speakup.png" width="100px" class="mb-3">
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12 d-flex justify-content-center">
                                <h1 class="fw-bold text-white mb-4">¡Descubre el poder de 
                                    nuestra plataforma con una
                                    PRUEBA GRATUITA POR 7 DÍAS!</h1>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12 d-flex justify-content-center">
                                <p class=" text-white mb-4">Disponibilidad de Aprender de los 50 Estados de EEUU.</p>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12 d-flex justify-content-center">
                                <p class=" text-white mb-4">Aprende sin anuncios ni interrupciones. </p>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12 d-flex justify-content-center">
                                <p class=" text-white mb-4">Vidas ilimitadas para que tu aprendizaje no tenga fin.</p>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12 d-flex justify-content-center">
                                <p class=" text-white mb-4">Practica 100% personalizada con la plataforma.</p>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12 d-flex justify-content-center">
                                <p class=" text-white mb-4">Interactúa con nuestra Inteligencia Artificial (Speaky).</p>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12 d-flex justify-content-center gap-3">
                                <button  mat-raised-button (click)="cerrarmodal()" class="text-white mr-2" color="warn" >NO gracias, en otro momento</button>
                                <button  mat-raised-button (click)="modalMembresia()" class="text-white" style="background-color: #50E170;">¡OBTENER SPEAK UP PREMIUM!</button>
                            </div>
                        </div>
                    </div>
                    <div class="col-1"></div>
                </div>
            </div>
        </div>
    </div>
</div>
<div *ngIf="termino === '3'" class="rounded" style="height: 90vh !important; background: linear-gradient(to bottom,#0B4595,#5578a8);">
    <div class="modal-content  d-none d-md-block rounded" style="height: 90vh !important;">
        <!-- <div class="modal-header w-100 p-2" style="background-color: rgb(57, 55, 177); color: #fff; border-radius: 1rem 1rem 0 0;">
            <h3 class="modal-title" class=" text-center"><strong> Log in</strong> </h3>
        </div> -->
       <!--  <button  matTooltip="SALIR"  style="position: absolute; top: 1%; left: 1%; z-index: 2;" (click)="cerrarmodal()"  mat-mini-fab color="primary"> 
            <mat-icon >reply</mat-icon>
        </button> -->
        <div class="modal-body ">
            <div class="w-100" style="padding: 1%">
                <div class="row mt-2">
                    <div class="col-1"></div>
                    <div class="col-10 container">
                        <div class="row">
                            <div class="col-12 d-flex justify-content-center">
                                <h1 class="fw-bold text-white mb-4">Conviértete en Miembro y obtén:</h1>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-auto  d-flex justify-content-center">
                                <p class=" text-white mb-4">Disponibilidad de Interactuar en los 50 Estados</p>
                            </div>
                            <div class="col-auto  d-flex justify-content-center">
                                <p class=" text-white mb-4">Sin anuncios, aprende sin interrupciones</p>
                            </div>
                            <div class="col-auto d-flex justify-content-center">
                                <p class=" text-white mb-4">Vidas Ilimitadas</p>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-6 d-flex justify-content-center">
                                <p class=" text-white mb-4">Práctica personalizada en tus lecciones con más deficiencia.</p>
                            </div>
                            <div class="col-6 d-flex justify-content-center">
                                <p class=" text-white mb-4">Dale estilo y personalización a tu Personaje.</p>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12 d-flex justify-content-center">
                                <p class=" text-white mb-4">Usa nuestra Inteligencia Artificial sin limitaciones para potenciar tu aprendizaje.</p>
                            </div>
                        </div>
                        <div class="row mb-2">
                            <div class="col-4 d-flex justify-content-center p-3">
                                <div class="card mat-elevation-z8" style="width: 18rem; background-color: #E7F0FD !important; border-radius: 1rem !important;" >
                                    <div class="card-body container">
                                      <div class="row">
                                        <div class="col-12 d-flex justify-content-center">
                                            <span *ngIf="membresia"  role="button" class="fw-bold mb-2" style="color: red;" >{{membresia[0]  | uppercase}} </span>
                                        </div>
                                      </div>
                                      <hr class="m-0 p-0" style="color: #16822E !important;">
                                      <div class="row">
                                        <div class="col-12 d-grid justify-content-center gap-2">
                                            <span *ngIf="membresia" class="fs-4 fw-bold my-2 text-center rubik"> {{membresia[1]}} MES</span>
                                            <span *ngIf="membresia" class="fs-2 fw-bold my-2 text-center rubik">$ {{membresia[2]}} </span>
                                        </div>
                                      </div>
                                      <hr class="m-0 p-0" style="color: #16822E !important;">
                                      <div class="row">
                                        <div class="col-12 d-grid justify-content-center gap-1">
                                            <span *ngIf="membresia" class="fs-6 rubik my-1">$ 8,99/mes</span>
                                            <span *ngIf="membresia" class="fs-6 my-1" style="color: #1CA33A !important;">Ahorra 0%</span>
                                        </div>
                                      </div>
                                      <div class="row">
                                        <div class="col-12 d-grid justify-content-center gap-1">
                                            <span *ngIf="membresia" class="fs-6 rubik my-1">ADQUIRIR 1 MES</span>
                                        </div>
                                      </div>
                                      <div class="row">
                                        <div *ngFor="let i of pasarela" class="col d-flex justify-content-center">
                                            <button  mat-raised-button  (click)="modalPasarela('2',i)" class="p-1 w-100" >
                                                <img [src]="i.cod_img" style=" width:60px; object-fit: 100%;">
                                            </button>
                                        </div>
                                      </div>
                                      <div class="row">
                                        <div class="col-12 d-flex justify-content-center">
                                            <!-- <span *ngIf="membresia" class="fs-6 rubik my-1">Iniciar Prueba Gratuita</span> -->
                                        </div>
                                      </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-4 d-flex justify-content-center">
                                <div class="card mat-elevation-z8" style="width: 18rem; background-color: #DCF9E2 !important; border-radius: 1rem !important;" >
                                    <div class="card-body container">
                                      <div class="row">
                                        <div class="col-12 d-flex justify-content-center">
                                            <button *ngIf="membresia"  mat-raised-button  class="text-white mb-2" color="warn" >{{membresia[6]  | uppercase}}</button>
                                        </div>
                                      </div>
                                      <hr class="m-0 p-0" style="color: #16822E !important;">
                                      <div class="row">
                                        <div class="col-12 d-grid justify-content-center gap-2">
                                            <span *ngIf="membresia" class="fs-4 fw-bold my-2 text-center rubik">{{membresia[7]}} MESES</span>
                                            <span *ngIf="membresia" class="fs-2 fw-bold my-2 text-center rubik">$ {{membresia[8]}}</span>
                                        </div>
                                      </div>
                                      <hr class="m-0 p-0" style="color: #16822E !important;">
                                      <div class="row">
                                        <div class="col-12 d-grid justify-content-center gap-1">
                                            <span *ngIf="membresia" class="fs-6 rubik my-1">$ 5,99/mes</span>
                                            <span *ngIf="membresia" class="fs-6 my-1" style="color: #1CA33A !important;">Ahorra 33%</span>
                                        </div>
                                      </div>
                                      <div class="row">
                                        <div class="col-12 d-grid justify-content-center gap-1">
                                            <span *ngIf="membresia" class="fs-6 rubik my-1">ADQUIRIR 12 MESES</span>
                                        </div>
                                      </div>
                                      <div class="row">
                                        <div *ngFor="let i of pasarela" class="col d-flex justify-content-center">
                                            <button  mat-raised-button  (click)="modalPasarela('8',i)" class="p-1 w-100" >
                                                <img [src]="i.cod_img" style=" width:60px; object-fit: 100%;">
                                            </button>
                                        </div>
                                      </div>
                                      <div class="row">
                                        <div class="col-12 d-flex justify-content-center">
                                            <!-- <span *ngIf="membresia" class="fs-6 rubik my-1">Iniciar Prueba Gratuita</span> -->
                                        </div>
                                      </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-4 d-flex justify-content-center p-3">
                                <div class="card mat-elevation-z8" style="width: 18rem; background-color: #E7F0FD !important; border-radius: 1rem !important;" >
                                    <div class="card-body container">
                                      <div class="row">
                                        <div class="col-12 d-flex justify-content-center">
                                            <span *ngIf="membresia"  role="button" class="fw-bold mb-2" style="color: red;">{{membresia[3]  | uppercase}}</span>
                                        </div>
                                      </div>
                                      <hr class="m-0 p-0" style="color: #16822E !important;">
                                      <div class="row">
                                        <div class="col-12 d-grid justify-content-center gap-2">
                                            <span *ngIf="membresia" class="fs-4 fw-bold my-2 text-center rubik">{{membresia[4]}} MESES</span>
                                            <span *ngIf="membresia" class="fs-2 fw-bold my-2 text-center rubik">$ {{membresia[5]}}</span>
                                        </div>
                                      </div>
                                      <hr class="m-0 p-0" style="color: #16822E !important;">
                                      <div class="row">
                                        <div class="col-12 d-grid justify-content-center gap-1">
                                            <span *ngIf="membresia" class="fs-6 rubik my-1">$ 6,37/mes</span>
                                            <span *ngIf="membresia" class="fs-6 my-1" style="color: #1CA33A !important;">Ahorra 25%</span>
                                        </div>
                                      </div>
                                      <div class="row">
                                        <div class="col-12 d-grid justify-content-center gap-1">
                                            <span *ngIf="membresia" class="fs-6 rubik my-1">ADQUIRIR 6 MESES</span>
                                        </div>
                                      </div>
                                      <div class="row">
                                        <div *ngFor="let i of pasarela" class="col d-flex justify-content-center">
                                            <button  mat-raised-button  (click)="modalPasarela('5',i)" class="p-1 w-100" >
                                                <img [src]="i.cod_img" style=" width:60px; object-fit: 100%;">
                                            </button>
                                        </div>
                                      </div>
                                      <div class="row">
                                        <div class="col-12 d-flex justify-content-center">
                                            <!-- <span class="fs-6 rubik my-1">Iniciar Prueba Gratuita</span> -->
                                        </div>
                                      </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12 d-flex justify-content-center gap-3 p-3">
                                <button  mat-raised-button (click)="cerrarmodal()" class="text-white mr-2" color="warn" >NO gracias, en otro momento</button>
                            </div>
                        </div>
                    </div>
                    <div class="col-1"></div>
                </div>
            </div>
        </div>
    </div>
</div>